// Check for HTML5 support
function supportsHtml5Storage() {
  try {
    return 'localStorage' in window && window.localStorage !== null;
  } catch (e) {
    return false;
  }
}

function isLocalStorageNameSupported() {
  const testKey = 'test';
  const storage = window.sessionStorage;

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);

    return true;
  } catch (error) {
    return false;
  }
}

function getItem(item) {
  if (supportsHtml5Storage() && isLocalStorageNameSupported()) {
    if (localStorage.getItem(item)) {
      return localStorage.getItem(item);
    }
  }

  return null;
}

function setItem(item, value) {
  if (supportsHtml5Storage() && isLocalStorageNameSupported()) {
    localStorage.setItem(item, value);
  }

  return Error('Local storage not supported');
}

function removeItem(item) {
  if (supportsHtml5Storage() && isLocalStorageNameSupported()) {
    localStorage.removeItem(item);
  }

  return Error('Local storage not supported');
}

export default { getItem, setItem, removeItem };
